export const BECOME_A_DELIVERY_DRIVER_LINK = 'https://food.yassir.com'

export const BECOME_A_RESTAURANT_PARTNER_LINK =
  'https://food.yassir.com/restaurant/registration'

export const WEBSITE_LINK = 'https://yassir.io/'

export const DOWNLOAD_THE_APP_LINK = 'https://yassir.io/en/download-the-app/'

export const BECOME_A_DRIVER_LINK = 'https://yassir.io/driver/'

export const ALGERIA_PHONE = '+213 782 09 00 00'
export const ALGERIA_PHONE_LINK = '+213 782 09 00 00'
export const ALGERIA_EMAIL = 'contact@food.yassir.io'
export const ALGERIA_EMAIL_LINK = 'mailto:contact@food.yassir.io'
export const ALGERIA_FACEBOOK_LINK = 'https://www.facebook.com/yassir.food'
export const ALGERIA_INSTAGRAM_LINK =
  'https://www.instagram.com/yassir.express.algerie/?igshid=tg39a8tzr82m'

export const TUNISIA_PHONE = '+216 31 36 00 00'
export const TUNISIA_PHONE_LINK = 'tel:+21631360000'
export const TUNISIA_EMAIL = 'contact@yassir.tn'
export const TUNISIA_EMAIL_LINK = 'mailto:contact@yassir.tn'
export const TUNISIA_FACEBOOK_LINK =
  'https://www.facebook.com/Yassir-Express-Tunisie-103345187807759'
export const TUNISIA_INSTAGRAM_LINK =
  'https://instagram.com/yassir.express.tunisie'

export const MOROCCO_PHONE = '+212 668 31 37 33'
export const MOROCCO_PHONE_LINK = 'tel:+212668313733'
export const MOROCCO_EMAIL = 'support.express@yassir.ma'
export const MOROCCO_EMAIL_LINK = 'mailto:support.express@yassir.ma'
export const MOROCCO_FACEBOOK_LINK =
  'https://www.facebook.com/yassirexpressmaroc/'
export const MOROCCO_INSTAGRAM_LINK = 'https://instagram.com/yassirexpressmaroc'
